import { render, staticRenderFns } from "./ModalDeleteRole.vue?vue&type=template&id=ac2f990c&scoped=true&lang=html&"
import script from "./ModalDeleteRole.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2f990c",
  null
  
)

export default component.exports